<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/C3rExv/tc-custom/9781954779402.jpg?1728851698189" alt="This image is the cover for the book Brass Starling, Willow Locke"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Brass Starling, Willow Locke
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In an alternate early twentieth-century New York—an immigrant’s daughter fights the forces of darkness to save her family—and finds an ally in Nikola Tesla . . .</b><br/>  <br/> When Thomas Edison’s corporate thugs steal her father's invention, Willow Locke must find a way to defend her family. Willow finds an unexpected ally in Nikola Tesla, who works in secret in a basement lab away from his main facility at Wardenclyffe, which he fears has been infiltrated by spies . . .<br/>  <br/> Tesla is creating advanced technology that is a century ahead of its time, but everything he makes must be kept hidden. Willow will use his inventions to unravel the corporate union-busters and protect her loved ones from violence. But in the course of her investigation she uncovers a hideous secret, an immortal enemy pulling the corporate strings, and a devastating plot for a final annihilation. Even with Tesla’s help, she is only one person. Can she stand against the forces of murder and darkness allied against her?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Isaac D. Peterson
      </h2>
      
      <p class="authorDescription body article">Isaac Peterson is a science fiction author who writes stories set in the past as well as the future. He is interested in science fiction as projections of facts, and though his stories are filled with weird technology and magic, he cares deeply about the reality of the world and brings in many real events and historical characters.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9c415c7a